/* Global imports. */
import React, { useState, useRef } from "react";
import HTMLReactParser from "html-react-parser";

/* Model imports. */
import { KontentFAQItem } from "@src/models/kontent";

/* Other imports. */
import arrow from "@images/icon--arrow-right.svg";

interface Props {
  items: Array<KontentFAQItem>;
}

const inactiveHeightClasses = "0px";
const inactiveRotateClasses = "transform duration-300 ease";

const FAQ = ({ items }: Props) => (
  <ul className="!pl-0 !list-none">
    {items.map((item) => {
      const [active, setActive] = useState(false);
      const [height, setHeight] = useState(inactiveHeightClasses);
      const [rotate, setRotate] = useState(inactiveRotateClasses);

      const content = useRef<HTMLDivElement>(null);

      function toggleState() {
        setActive(!active);
        setHeight(active ? inactiveHeightClasses : `${content.current?.scrollHeight}px`);
        setRotate(active ? inactiveRotateClasses : `${inactiveRotateClasses} rotate-90`);
      }

      return (
        <li className="list-none">
          <dt
            className="flex items-center justify-between py-5 border-b-2 border-gray-300 border-solid appearance-none cursor-pointer"
            role="presentation"
            onClick={toggleState}
          >
            <h5 className="font-sans font-bold">{item.elements.header.value}</h5>
            <img src={arrow} alt="" className={`${rotate} h-4`} />
          </dt>
          <dd
            ref={content}
            style={{ maxHeight: `${height}` }}
            className="overflow-auto duration-300 ease-in-out transition-max-height"
          >
            <div className="py-4">{HTMLReactParser(item.elements.content.value)}</div>
          </dd>
        </li>
      );
    })}
  </ul>
);

export default FAQ;
